import { JSX } from "react";
import { BasicRecord } from "./basicRecord";
import { BasicTable } from "./BasicTable";
import { SummaryResultNetworkType, SummaryResultType } from "./enumerations";

interface ByStateProps {
  providersEndpointFunc: (networkType: SummaryResultNetworkType, resultType: SummaryResultType, key: string) => string;
  records: BasicRecord[];
}

const ByState = (props: ByStateProps): JSX.Element => <BasicTable {...props} records={props.records} tableName="State" />;

export { ByState };
